<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_search') || '校验单号/采购单号/订单号/供应商 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditPage', { pageType: 'add' })"
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
            <slot :form="form" />
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-drawer
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :visible.sync="advqueryDialogVisible"
      size="600px"
      :close-on-click-modal="false"
      append-to-body
      :with-header="false"
    >
      <div class="d-flex" style="justify-content: space-between; margin: 20px;">
        <div style="color: #101010;font-size: 14px;">
          高级搜索
        </div>
        <div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeAdvqueryDialog">
              {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
            </el-button>
            <el-button size="small" type="warning" @click="reset">
              {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
            </el-button>
            <el-button size="small" type="primary" @click="advquery">
              {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
            </el-button>
          </span>
        </div>
      </div>

      <div class="ml-4 mr-4">
        <el-form
          ref="form"
          :model="form"
          label-position="right"
          size="mini"
          label-width="100px"
        >
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_materialInspectionStatus') || '单据状态'"
              >
                <dict-check-box
                  :checkList="form.statusList"
                  @change="handleStatusChange"
                  size="small"
                  url="/sys/common/dict/system"
                  :body="{ dictType: 'MRP_MATERIAL_INSPECTION_STATUS' }"
                ></dict-check-box>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_auditResult') || '审核结果'"
              >
                <dict-check-box
                  :checkList="form.auditResultList"
                  @change="handleAuditResultChange"
                  size="small"
                  url="/sys/common/dict/system"
                  :body="{ dictType: 'MRP_MATERIAL_AUDIT_RESULT_TYPE' }"
                ></dict-check-box>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_inspectionNo') || '检验单号'"
              >
                <el-input
                  v-model.trim="form.inspectionNo"
                  :placeholder="
                    $l('form_please_inspectionNo') || '请输入检验单号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_purchaseMaterialNo') || '采购单号'"
              >
                <el-input
                  v-model.trim="form.purchaseMaterialNo"
                  :placeholder="
                    $l('form_please_purchaseMaterialNo') || '请输入采购单号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_originOrderNo') || '源头订单号'"
              >
                <el-input
                  v-model.trim="form.originOrderNo"
                  :placeholder="
                    $l('form_please_originOrderNo') || '请输入源头订单号'
                  "
                  clearable
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item :label="$l('form_label_scmName') || '供方'">
                <dict-select
                  :placeholder="
                    $l('form_placeholder_scmName') || '请选择供方...'
                  "
                  size="small"
                  clearable
                  filterable
                  multiple
                  v-model="form.scmCodeList"
                  url="/master/common/dict/scmPartners"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_purchaserEntityCode') || '需方'"
              >
                <dict-select
                  v-model="form.purchaserEntityCodeList"
                  url="/master/common/dict/biz"
                  :body="{ dictType: 'orderSource' }"
                  :placeholder="
                    $l('form_placeholder_purchaserEntityCode') ||
                      '请选择需方...'
                  "
                  size="small"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_buyerName') || '采购人员'">
                <dict-select
                  v-model="form.buyerCodeList"
                  multiple
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_please_buyerName') || '请选择采购人员...'
                  "
                  size="mini"
                  clearable
                  style="width: 100%"
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_reporterName') || '质检员'">
                <dict-select
                  v-model="form.reporterCodeList"
                  multiple
                  url="/master/common/dict/baseUserSelect"
                  :placeholder="
                    $l('form_please_reporterName') || '请选择质检员...'
                  "
                  size="mini"
                  clearable
                  style="width: 100%"
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item :label="$l('form_label_materialNo') || '物料编码'">
                <el-input
                  clearable
                  v-model="form.materialNo"
                  size="mini"
                  style="width: 100%"
                  :placeholder="
                    $l('form_please_materialNo') || '请输入物料编码'
                  "
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_materialName') || '物料名称'"
              >
                <el-input
                  clearable
                  v-model="form.materialName"
                  :placeholder="
                    $l('form_please_materialName') || '请输入物料名称'
                  "
                  size="mini"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_materialDesc') || '规格型号'"
                prop="materialDesc"
              >
                <el-input
                  clearable
                  v-model="form.materialDesc"
                  :placeholder="
                    $l('form_please_materialDesc') || '请输入规格型号'
                  "
                  size="mini"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_materialRequirement') || '材质要求'"
              >
                <el-input
                  clearable
                  v-model="form.materialRequirement"
                  :placeholder="
                    $l('form_please_materialRequirement') || '请输入材质要求'
                  "
                  size="mini"
                  style="width: 100%"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                :label="$l('form_label_inspectionResult') || '检验结果'"
              >
                <dict-select
                  v-model="form.inspectionResultList"
                  url="/sys/common/dict/system"
                  :body="{ dictType: 'inspectionResult' }"
                  :placeholder="
                    $l('form_please_inspectionResult') || '请选择检验结果...'
                  "
                  size="mini"
                  style="width: 100%"
                  filterable
                  clearable
                  multiple
                ></dict-select>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="$l('form_label_arrivalDate') || '实际到料日期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginArrivalDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_placeholder_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endArrivalDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_placeholder_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="$l('form_label_inspectionDate') || '检验日期'"
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginInspectionDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_placeholder_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endInspectionDate"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_placeholder_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>

            <el-col :span="24">
              <el-row>
                <el-form-item :label="$l('INDEX.create_date') || '创建时间'">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginCreateTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_placeholder_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endCreateTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_placeholder_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-row>
                <el-form-item
                  :label="
                    $l('INDEX.form_label_modification_time') || '修改时间'
                  "
                >
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.beginModifyTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_placeholder_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.endModifyTime"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_placeholder_date') || '选择日期'"
                      style="width: 100%"
                    >
                    </el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_createBy') || '创建人'">
                <dict-select
                  v-model="form.createByList"
                  multiple
                  url="/master/common/dict/baseUserSelect"
                  size="mini"
                  :placeholder="$l('form_placeholder_please_create_by') || '请选择创建人'"
                  clearable
                  style="width: 100%"
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$l('form_label_modifyBy') || '修改人'">
                <dict-select
                  v-model="form.modifyByList"
                  multiple
                  url="/master/common/dict/baseUserSelect"
                  size="mini"
                  :placeholder="$l('form_placeholder_please_modify_by') || '请选择修改人'"
                  clearable
                  style="width: 100%"
                  filterable
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import DictCheckBox from '@/views/factory/components/dict-check-box'

// 初始表单
const initForm = {
  keyword: '',
  statusList: ['A', 'C', 'N', 'Q', 'R']
}
export default {
  components: {
    DictCheckBox
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm }
    }
  },
  created() {
    this.query()
  },
  methods: {
    handleStatusChange(val) {
      this.form.statusList = val
    },
    handleAuditResultChange(val) {
      this.form.auditResultList = val
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
